import React from 'react';

interface ReferralInviteProps { }
interface ReferralInviteState { }

class ReferralInvite extends React.Component<ReferralInviteProps, ReferralInviteState> {

    constructor(props_: ReferralInviteProps) {
        super(props_);

        this.state = {}
    }

    componentDidMount(): void {
        const ua = navigator.userAgent;

        const isIOS = /iPhone|iPad|iPod/i.test(ua);

        const appLink = isIOS
            ? "passportpay://"
            : "intent://home#Intent;scheme=passportpay;package=com.priority.passportpay;end";

        const storeLink = isIOS
            ? "https://apps.apple.com/us/app/passportpay/id6738844617"
            : "https://play.google.com/store/apps/details?id=com.priority.passportpay";

        let appOpened = false;

        const handleVisibility = () => {
            if (document.hidden) {
                appOpened = true;
            }
        };

        document.addEventListener("visibilitychange", handleVisibility);

        window.location.href = appLink;

        setTimeout(() => {
            document.removeEventListener("visibilitychange", handleVisibility);

            if (!appOpened) {
                window.location.href = storeLink;
            }
        }, 2000);
    }

    public render() {
        return (
            <div style={{
                display: 'flex', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center', fontSize: 20
            }}>Please wait. Redirecting you to the mobile app..</div>
        )
    }
}

export default ReferralInvite;